<template>
  <article class="col-lg-12 gp-campaign-report0 pt-2">
    <ReportModal :campaign="details" @close="goBack" />
  </article>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { actions } from "@/store/analytic/types.js";
import { ReportModal } from "../components";
import errorHandle from "@/mixins/errorHandle.js";
import routeGuard from "@/mixins/routeGuard";

export default {
  name: "CampaignDetail",
  components: {
    ReportModal
  },
  mixins: [errorHandle(), routeGuard("analytics")],
  data: () => ({
    loading: false,
    fetched: null,
    copied: false,
    alertText: ""
  }),
  computed: {
    ...mapState("analytic", {
      attach: state => state.attach
    }),
    details() {
      let output = {};
      if (this.attach) {
        output = JSON.parse(JSON.stringify(this.attach));
      }
      const id = this.$route?.params?.id;
      output.id = id;
      if (this.fetched) {
        output = { ...output, ...JSON.parse(JSON.stringify(this.fetched)) };
      }
      return output;
    }
  },
  created() {
    this.loading = true;
    this.fetchDetail({
      id: (this.attach && this.attach.id) || this.$route.params.id
    })
      .then(res => {
        this.fetched = res;
      })
      .catch(() => {
        this.gSnackbarCommit({
          message: this.$t("status.error"),
          type: "error"
        });
        // this.$router.push({ name: "ABTesting"});
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions("analytic", {
      fetchDetail: actions.FETCH_DETAIL_ANALYTIC
    }),
    goBack() {
      if (this.previousRoute) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "ABTesting" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
